import styled from 'styled-components';

const StyledLabel = styled.label`
  width: ${props => (props.width ? props.width : '100%')};
  color: ${props => props.theme.secondaryColor || '#000000'};
  font-size: 14px;
  font-weight: 600;
`;

export default StyledLabel;
